<template lang="pug">
.container
  #wrap_sub
    .sub_right
      .content_desc
        #s21
          .s21a.sub
            .in
              h2.s_tit
                span INTHEKEG
              p.ss_tit
                span.bold INTHEKEG 
                | is not just a simple beer maker but a completely new concept of a
                br
                span.bold Smart Brewery Platform 
                | that can produce and supply craft beers.
              .cont
                img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s21a.png' alt='' data-aos='fade-up')
                h3(data-aos='fade-up')
                  | The most important value we want to bring to our customers with INTHEKEG's Smart Brewery Platform goes beyond simply 
                  span.bold helping them to produce and sell beer with ease. 
                  | Our value extents to 
                  span.bold.yell to fully enjoy various kinds of made beer at the peak of freshness. 
          .s21b.sub
            .in
              h2.sb_tit(data-aos='fade-up')
                | Simply add a SMARTKEG and press the start button.
                br
                | After about seven days, your craft beer will be ready to serve.
              p(data-aos='fade-up' data-aos-delay='100') While the conventional beer brewing process is time consuming/costly/need large space, thus deteriorates the beer quality. With the use of INTHEKEG, however, you can simply add a SMARTKEG and ferment, age, and sell fresh beer of various kinds efficiently.
              .cont
                .lt
                  .top
                    .top_lt.lt_lt(data-aos='fade-right')
                      .tl_wrap
                        p Conventional 
                          br
                          | Brewery
                    .top_rg.lt_rg(data-aos='fade-right' data-aos-delay='300')
                      .info
                        .info1
                          .top
                          .bot
                            .lt
                              p Malt/hop
                                br.t_n
                                |  selection
                            .rg.rg_box
                              p Wort production: 
                                br.t_n
                                span 6~8
                                | hours
                      .img
                        img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/top_rg.png' alt='')
                  .mid(data-aos='fade-down' data-aos-delay='500')
                    .mid_lt.lt_lt
                    .mid_rg.lt_rg
                      img(:src='require("../../assets/images/s21b_arr.png")' alt='')
                  .bot(data-aos='fade-down' data-aos-delay='700')
                    .bot_lt.lt_lt
                      .bl_wrap.tl_wrap
                        p INTHEKEG
                    .bot_rg.lt_rg
                      .img
                        h3 SMARTKEG
                        img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/bot_rg.png' alt='')
                        p 6~8 hours
                .rg
                  .top
                    .top_rg.lt_rg(data-aos='fade-right' data-aos-delay='400')
                      .info
                        .info1
                          .top
                            .top_in
                              p The taste of beer affected by production conditions, such as climate, temperature, and operators
                          .bot
                            .lt
                              p Fermentation: 
                                br.t_n
                                span 5~12
                                | days 
                            .rg
                              p Aging:
                                br
                                span 7~14
                                | days
                        .info1
                          .top
                            .top_in
                              p Fresh flavor and aroma reduced
                            .top_in
                              p Oxygen penetrating during the packaging process Oxidation initiated during the distribution process
                          .bot
                            .lt
                              p Sterilization and filtration 
                                br.t_n
                                span 1~2
                                | hours
                            .rg
                              p Packaging and delivery 
                                br.t_n
                                span 1~7
                                | days
                      .img
                        img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/top_rg2.png' alt='')
                  .mid(data-aos='fade-down' data-aos-delay='500')
                    .mid_lt.lt_lt
                    .mid_rg.lt_rg
                      img(:src='require("../../assets/images/s21b_arr.png")' alt='')
                  .bot(data-aos='fade-down' data-aos-delay='900')
                    .bot_lt.lt_lt(style='display:none')
                      .bl_wrap
                        p INTHEKEG
                    .bot_rg.lt_rg
                      .img
                        h3 INTHEKEG
                        img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/bot_rg2.png' alt='')
                        p 7~12 days
          .s21c.sub
            .in
              h2.sb_tit(data-aos='fade-up')
                | Smart Brewery
              p(data-aos='fade-up' data-aos-delay='300')
                span.bold The INTHEKEG system 
                | minimizes the  input of space, equipment, cost, and labor for beer production.
              .cont
                .lt(data-aos='fade-right')
                  h3 Conventional Brewery Pub
                  .box
                    img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s21c_01.jpg' alt='')
                    .info
                      .i_list
                        h4 Investment cost
                        .txt
                          div
                            span
                              img(:src='require("../../assets/images/s21c_icon1.png")' alt='')
                            p $300,000
                      .i_list
                        h4 Beer type
                        .txt
                          div
                            span
                              img(:src='require("../../assets/images/s21c_icon2.png")' alt='')
                            p Up to 6
                      .i_list
                        h4 Required operators
                        .txt
                          div
                            span
                              img(:src='require("../../assets/images/s21c_icon3.png")' alt='')
                            p 3.0
                      .i_list
                        h4 Production volume
                        .txt
                          div
                            span
                              img(:src='require("../../assets/images/s21c_icon4.png")' alt='')
                            p 3,000 liters every three weeks
                .rg(data-aos='fade-right' data-aos-delay='100')
                  h3 Smart Brewery
                  .box
                    img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s21c_02.jpg' alt='')
                    .info
                      .i_list
                        h4 Investment cost
                        .txt
                          div
                            span
                              img(:src='require("../../assets/images/s21c_icon5.png")' alt='')
                            p $45,000
                      .i_list
                        h4 Beer type
                        .txt
                          div
                            span
                              img(:src='require("../../assets/images/s21c_icon6.png")' alt='')
                            p Up to 60
                      .i_list
                        h4 Required operators
                        .txt
                          div
                            span
                              img(:src='require("../../assets/images/s21c_icon7.png")' alt='')
                            p 0.1
                      .i_list
                        h4 Production volume
                        .txt
                          div
                            span
                              img(:src='require("../../assets/images/s21c_icon8.png")' alt='')
                            p 3,150 liters every three weeks
          .s21d.sub
            .in
              h2.sb_tit(data-aos='fade-up')
                | The world's one and only Ai-based craft beer brewing system
              p(data-aos='fade-up' data-aos-delay='300') The INTHEKEG system is the world's one and only AI-based craft beer brewing system.
              img.ani(:src='require("../../assets/images/s21d.png")' alt='')
              .box
                span
                  img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s21d01.png' alt='' data-aos='fade-right' data-aos-delay='200')
                span
                  img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s21d02.png' alt='' data-aos='fade-right' data-aos-delay='100')
                span
                  img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s21d03.png' alt='' data-aos='fade-left')
          .s21f.sub
            .in
              h2.sb_tit(data-aos='fade-up')
                | Real-time monitoring system
              p(data-aos='fade-up' data-aos-delay='300') The INTHEKEG system monitors in real time for the all the factors that can affect the taste and quality of beer, such as temperature, pressure, and time duration. 
                br
                | With its embedded sensors, the system analyzes the beer brewing process 24/7. Monitoring operates based on AI and accumulated data ensures the optimal fermentation and aging of beer at all times.
              .cont
                .lt
                  .top(data-aos='fade-right')
                    h3 Display
                    ul
                      li
                        p Enables real-time recipe updates based on the Beer Care System, and the remote-control system
                      li
                        p Allows easy fermentation/aging/extraction operations with a touch display
                      li
                        p Helps monitor each cell's fermentation and aging status
                      li
                        p Checks the beer level in the SMARTKEG while giving notifications for keg replacement
                  .bot(data-aos='fade-right' data-aos-delay='200')
                    h3 Dispenser
                    ul
                      li
                        p Allows beers to be independently extracted from each cell
                      li
                        p Equipped with an auto flushing function to prevent different beers from mixing even after the beer type has been changed
                      li
                        p Gives a notification for daily cleaning at a designated time
                .md
                  div
                    img(:src='require("../../assets/images/s21f_icon01.png")' alt='')
                  div
                    span.top
                    span.mid
                    span.bot
                    img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s21f.png' alt='')
                  div
                    img(:src='require("../../assets/images/s21f_icon02.png")' alt='')
                    p Fits in a small space because it is designed 
                      span.yell to rotate 180 degrees
                .rg
                  .top(data-aos='fade-left' data-aos-delay='300')
                    h3 Cell
                    ul
                      li
                        p With each cell independently controlled
                      li
                        p With the optimal fermentation tailored to each beer type, beer production takes about a week
                      li
                        p Ensures craft beer with a wide range of flavors and aromas with its automatic yeast feeding and dry hopping functions
                      li
                        p Easy to maintain with its one-touch automatic sterilization and cleaning functions
                      li
                        p Ensures that the quality and taste of beer inside the system can be maintained for up to six months
                .mo
                  .lt
                    .top(data-aos='fade-right')
                      h3 Display
                      ul
                        li
                          p Enables real-time recipe updates based on the Beer Care System, and the remote-control system
                        li
                          p Allows easy fermentation/aging/extraction operations with a touch display
                        li
                          p Helps monitor each cell's fermentation and aging status
                        li
                          p Checks the beer level in the SMARTKEG while giving notifications for keg replacement
                    .bot(data-aos='fade-right')
                      h3 Dispenser
                      ul
                        li
                          p Allows beers to be independently extracted from each cell
                        li
                          p Equipped with an auto flushing function to prevent different beers from mixing even after the beer type has been changed
                        li
                          p Gives a notification for daily cleaning at a designated time
                  .rg
                    .top(data-aos='fade-right')
                      h3 Cell
                      ul
                        li
                          p With each cell independently controlled
                        li
                          p With the optimal fermentation tailored to each beer type, beer production takes about a week
                        li
                          p Ensures craft beer with a wide range of flavors and aromas with its automatic yeast feeding and dry hopping functions
                        li
                          p Easy to maintain with its one-touch automatic sterilization and cleaning functions
                        li
                          p Ensures that the quality and taste of beer inside the system can be maintained for up to six months
          #smartkeg.s21e.sub(ref="smartkeg")
            .in
              h2.s_tit
                span SMARTKEG
              h2.sb_tit(data-aos='fade-up')
                span.bold The SMARTKEG 
                | is a keg that contains wort 
                br
                | and 
                span.bold Yeast 
                | capsules, raw materials for beer.
              p.ss_tit(data-aos='fade-up' data-aos-delay='300') The SMARTKEG is 
                span.bold.yell a product package that provides the best solution 
                | to producing, distributing, and selling a wide range of alcoholic drinks and beverages based on its patented structure and design.
              .cont
                .lt
                  .top(data-aos='fade-right')
                    img(:src='require("../../assets/images/s21e_01.png")' alt='')
                    h3 The automatic yeast feeding system
                    p This system allows the yeast stored in the form of a capsule to be automatically fed for the fermentation and aging process according to the selected beer recipe.
                .md
                  span.top
                  span.bot
                  img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s21e.png' alt='')
                .rg
                  .top(data-aos='fade-left' data-aos-delay='200')
                    img(:src='require("../../assets/images/s21e_02.png")' alt='')
                    h3 Keg cap  + QR code
                    p Each keg cap is labeled with a QR code that is linked to beer recipes. This system allows you to easily access the beer recipes you want.
                  .bot(data-aos='fade-left' data-aos-delay='400')
                    h3 A plastic keg with a capacity of 17.5 liters
                    p This one-way keg is not required to be cleaned or collected after use but can be recycled. Equipped with oxidation preventing and UV blocking functions to ensure the freshness of beer.
                .mo
                  .top(data-aos='fade-right')
                    img(:src='require("../../assets/images/s21e_01.png")' alt='')
                    h3 The automatic yeast feeding system
                    p This system allows the yeast stored in the form of a capsule to be automatically fed for the fermentation and aging process according to the selected beer recipe.
                  .mid(data-aos='fade-right')
                    img(:src='require("../../assets/images/s21e_02.png")' alt='')
                    h3 Keg cap  + QR code
                    p Each keg cap is labeled with a QR code that is linked to beer recipes. This system allows you to easily access the beer recipes you want.
                  .bot(data-aos='fade-right')
                    h3 A plastic keg with a capacity of 18 liters
                    p This one-way keg is not required to be cleaned or collected after use but can be recycled. Equipped with oxidation preventing and UV blocking functions to ensure the freshness of beer.
          .s21g.sub
            .in
              h2.sb_tit BEER RECIPE
              p SMARTKEGs that come with various recipes are currently being sold, and new recipes will continue to be added.
              .cont
                .recipe
                  .r_list(v-for="row in beerCard" :key="row.IDX")
                    .basic(:class='[!beer[row.IDX] ? "on" : ""]')
                      .img
                        img(:src='row.LIST_IMG' alt='')
                      .txt
                        h3 {{row.EN_NAME}}
                        p.info ABV : {{row.ABV}}%&nbsp;&nbsp;&nbsp;IBU : {{row.IBU}}
                        p.info2 {{row.EN_SIMPLE_EXPLAIN}}
                      .c_btn
                        a(@click='toggleBeer(row.IDX)') VIEW MORE
                          img(:src='require("../../assets/images/c_btn.png")' alt='')
                    .click(:class='[beer[row.IDX] ? "on" : ""]')
                      .img.detail_img
                        img(:src='row.DETAILED_IMG' alt='')
                      .txt
                        p.c_info1 {{row.EN_DETAILED_EXPLAIN}}
                        .t_box
                          .t_top
                            h3 Food pairing
                            p {{row.EN_FOOD}}
                          .t_bot
                            h3 Aroma
                            p {{row.AROMA}}
                      .c_btn
                        a(@click='toggleBeer(row.IDX)') CLOSE
                          img(:src='require("../../assets/images/c_btn.png")' alt='')
          .s21h.sub
            .in
              h2(data-aos='fade-down')
                | Please contact our sales manager 
                br
                | if you have any inquiries regarding a partnership 
                br 
                span.bold.yell with INTHEKEG for beer recipes.
              .con_btn(data-aos='fade-down' data-aos-delay='200')
                a(@click='$_goTo({name: "contact"})') Contact
                  img(:src='require("../../assets/images/v_btn.png")' alt='')
          #BeerCareSystem.s21i.sub(ref="BeerCareSystem")
            .in
              h2.s_tit
                span Beer Care System
              h2.sb_tit
                | INTHEKEG's Beer Care System automatically checks the internal and external conditions of the devices to ensure the optimal fermentation and aging of beer. 
                br 
                | All data generated from the devices (beer fermentation, aging, storage, device operations, CO2 tank management, etc.) are collected and saved on the server. 
                br
                | The stored data are processed and provided by each phase, including beer production, distribution, and sales.
              .cont
                .i01(data-aos='fade-right')
                  img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s21i_01.png' alt='')
                .i02.process(data-aos='fade-right' data-aos-delay='200')
                  p Status and operation data
                .i03(data-aos='fade-up' data-aos-delay='400')
                  .list
                    h3 Beer Care System
                    ul
                      li
                        p Device monitoring
                      li
                        p Beer production management
                      li
                        p Beer recipe management
                      li
                        p Equipment and membership management
                      li
                        p Service statistics
                .i04.process(data-aos='fade-left' data-aos-delay='200')
                  p Monitoring push notification
                .i05(data-aos='fade-left')
                  img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s21i_02.png' alt='')
              .bot
                .img(data-aos='fade-down')
                  img.pc(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/i_cir_en.png' alt='' v-if="!isMobile")
                  img.mo(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/i_cir_mo_en.png' alt='' v-if="isMobile")
                .txt
                  ul
                    li(data-aos='fade-right')
                      p.num 01
                      p.con_txt INTHEKEG's Beer Care System automatically checks the internal and external conditions of the devices to ensure the optimal fermentation and aging of beer.
                    li(data-aos='fade-right' data-aos-delay='200')
                      p.num 02
                      p.con_txt All data generated from the devices (beer fermentation, aging, storage, device operations, CO2 tank management, etc.) are collected and saved on the server.
                    li(data-aos='fade-right' data-aos-delay='400')
                      p.num 03
                      p.con_txt The stored data are suitably processed and provided by each phase, including beer production, distribution, and sales.
          .s21j.sub
            .in
              .cont(data-aos='fade-right')
                img.pc(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/j_cont.png' alt='' v-if="!isMobile")
                img.mo(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/j_cont_mo.png' alt='' v-if="isMobile")
                .txt
                  .lt
                    h3 INTHEKEG
                    ul
                      li
                        p
                          span.bold Weight:
                          |  230kg
                      li
                        p
                          span.bold Color:
                          |  Mat black
                  .rg
                    h3 SMARTKEG
                    ul
                      li
                        p
                          span.bold Weight:
                          |  20kg
                      li
                        p
                          span.bold Color:
                          |  Brown/no color
          .s21k.sub
            .in
              h2.sb_tit(data-aos='fade-up')
                | Patents
              p(data-aos='fade-up' data-aos-delay='200') INTHEKEG's innovative technology has been widely recognized with domestic patents, and PCT applications have been further filed in 152 countries across the globe for patent rights protection.
              .cont
                .top
                  .cont1
                    h3 Beer production-related patents
                    ul
                      li(data-aos='fade-right')
                        p Beer production apparatus
                      li(data-aos='fade-right' data-aos-delay='200')
                        p Beer brewing machine and beer brewing method using the same
                      li(data-aos='fade-right' data-aos-delay='400')
                        p Beer-making device using contactless fermentation degree-measuring method, and the control method of a beer-making device
                      li(data-aos='fade-right' data-aos-delay='600')
                        p Keg cap integrated with a yeast capsule, coupler for the coupling keg cap integrated with a yeast capsule, and beer-making device provided with the same
                  .cont2(data-aos='fade-down' data-aos-delay='800')
                    img(:src='require("../../assets/images/k_arr.png")' alt='')
                  .cont3
                    h4(data-aos='fade-down' data-aos-delay='1000') Four domestic patents have been registered, and patent applications have been filed in the US, China, and India.
                    ul
                      li(data-aos='fade-right' data-aos-delay='1200')
                        img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/certi1.jpg' alt='')
                      li(data-aos='fade-right' data-aos-delay='1400')
                        img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/certi2.jpg' alt='')
                      li(data-aos='fade-right' data-aos-delay='1600')
                        img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/certi3.jpg' alt='')
                      li(data-aos='fade-right' data-aos-delay='1800')
                        img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/certi4.jpg' alt='')
                .bot
                  .cont1
                    h3 Fermented liquor and beverage production-related patents
                    ul
                      li(data-aos='fade-right')
                        p Apparatus for manufacturing a fermented liquor (8 items) 
                      li(data-aos='fade-right' data-aos-delay='200')
                        p Control method of the fermented liquor-making device
                      li(data-aos='fade-right' data-aos-delay='400')
                        p Keg cap, and keg provided with the same
                  .cont2(data-aos='fade-down' data-aos-delay='600')
                    img(:src='require("../../assets/images/k_arr.png")' alt='')
                  .cont3(data-aos='fade-down' data-aos-delay='800')
                    h4 Ten domestic patent applications have been filed.
          .s21l.sub
            .in
              .top
                h2 Awards and Honors
                .aw_list
                  .list
                    .img
                      img(:src='require("../../assets/images/logo1.png")' alt='')
                    h3 CES 2020 Innovation Award
                    ul
                      li Drones &amp; Unmanned Systems
                      li Home Appliances
                  .list
                    .img
                      img(:src='require("../../assets/images/logo2.png")' alt='')
                    h3 CES 2021 Innovation Award
                    ul
                      li Drones &amp; Unmanned Systems
                  .list
                    .img
                      img(:src='require("../../assets/images/logo3.png")' alt='')
                    h3 2020 Korea Good Design (GD) Award
                  .list
                    .img
                      img(:src='require("../../assets/images/logo4.png")' alt='')
                    h3 2020 KIPO Commissioner Award at the Korea Invention Patent Exhibition
                  .list
                    .img
                      img(:src='require("../../assets/images/logo5.png")' alt='')
                    h3 IF Design Award
                    ul
                      li INTHEKEG - Product Design
                      li INTHEKEG HOME - Product Concepts
                  .list
                    .img
                      img(:src='require("../../assets/images/logo6.png")' alt='')
                    h3 IR52 Jang Young-Shil Award
              .mid
                h2 Video Review
                .cont
                  .lt
                    .vd
                      iframe(width='560' height='350' src='https://www.youtube.com/embed/9GcwPfRZthE' title='YouTube video player' frameborder='0' allow='accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen='')
                    h3 Introduction of INTHEKEG
                  .rg
                    .vd
                      iframe(src='https://www.cnet.com/videos/share/inthekeg-is-a-10000-monolithic-machine-that-brews-beer/' width='560' height='350' frameborder='0' allowfullscreen='' scrolling='no' seamless="seamless")
                    h3 CNET INTHEKEG review
              .bot
                h2 Download
                ul
                  li
                    a(href="https://office--file.s3.ap-northeast-2.amazonaws.com/pdf/INTHEKEG_Brochure_en.88d1f2c0.pdf" target='_blank')
                      div
                        p INTHEKEG Brochure [en]
                        p Download 
                          img(:src='require("../../assets/images/down_icon.png")' alt='')
                  li
                    a(href="https://office--file.s3.ap-northeast-2.amazonaws.com/pdf/INTHEKEG_QG_en.f0e2d67c.pdf" target='_blank')
                      div
                        p INTHEKEG Quick Guide
                        p Download 
                          img(:src='require("../../assets/images/down_icon.png")' alt='')


</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      beer: {},
      beerCard: [],
    };
  },
  computed: {
    ...mapGetters(['lan']),
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      );
    },
  },
  methods: {
    toggleBeer(num) {
      let res = this.beer[num];
      this.beer[num] = !res;
    },
    getData() {
      this.$_axios('GET', 'board/content/beercard').then(res => {
        this.beerCard = res.data.res;
        let temp = {};
        this.beerCard.forEach(e => {
          temp[e.IDX] = false;
        });
        this.beer = temp;
      });
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$nextTick(() => {
      if (this.$route.params.place) {
        let place = this.$route.params.place;
        document.getElementById(place).scrollIntoView({ behavior: 'auto' });
      }
    });
  },
};
</script>
<style>
@import '../../assets/css/en/en_default.css';
@import '../../assets/css/en_common_fir.css';
@import '../../assets/css/en_common_sec.css';
@import '../../assets/css/en_common_thi.css';

@media (max-width: 768px) {
  .cont .rg .vd iframe,
  .cont .lt .vd iframe {
    height: 210px;
  }
  .s21l .mid .cont h3 {
    margin-top: 30px;
  }
  .s21i .cont > div img {
    margin: 0 auto;
  }
  .s21b .cont .lt_lt .tl_wrap {
    width: 100%;
    height: 60px;
    border: 3px solid rgba(255, 255, 255, 0.6);
    border-radius: 0;
  }
}
</style>
